import KendoInputsInstaller from './kendo-inputs-installer'
import KendoNumericTextBox from './KendoNumericTextBox'
import KendoColorPicker from './KendoColorPicker'
import KendoColorPalette from './KendoColorPalette'
import KendoFlatColorPicker from './KendoFlatColorPicker'
import KendoMaskedTextBox from './KendoMaskedTextBox'
import KendoSlider from './KendoSlider'
import KendoRangeSlider from './KendoRangeSlider'
import KendoSwitch from './KendoSwitch'

export { KendoInputsInstaller, KendoInputsInstaller as InputsInstaller, KendoNumericTextBox, KendoNumericTextBox as NumericTextBox, KendoColorPicker, KendoColorPicker as ColorPicker, KendoColorPalette, KendoColorPalette as ColorPalette, KendoFlatColorPicker, KendoFlatColorPicker as FlatColorPicker, KendoMaskedTextBox, KendoMaskedTextBox as MaskedTextBox, KendoSlider, KendoSlider as Slider, KendoRangeSlider, KendoRangeSlider as RangeSlider, KendoSwitch, KendoSwitch as Switch }


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/index.js